import { IBookmarkUpdate } from '../models/Bookmarks/IBookmarkUpdate';
import { commonService } from './commonDashboardApiService';

function bookmarkService() {
  function getBookmarksPaged<IBookmarksContainer>(
    ssoUUId: string,
    bookmarkType: number,
    sortOrder: number,
    pageSize: number,
    pageNumber: number
  ) {
    return commonService.get<IBookmarksContainer>('api/bookmark/getall', {
      params: {
        ssouuid: ssoUUId,
        bookmarkType: bookmarkType,
        sortOrder: sortOrder,
        pageSize: pageSize,
        pageNumber: pageNumber,
      },
    });
  }

  function updateNote(data: IBookmarkUpdate) {
    return commonService.post('api/bookmark/EditNotes', data);
  }

  function deleteBookmark(ssoUUId: string, bookmarkId: number) {
    return commonService.del(`api/bookmark/${bookmarkId}`, {
      params: {
        ssouuid: ssoUUId,
      },
    });
  }

  return {
    getBookmarksPaged,
    updateNote,
    deleteBookmark,
  };
}

export default bookmarkService;
